module.exports = __webpack_public_path__ + "img/tu_file_view.54ea3208.svg";